import { appLocalStorage } from 'utils/misc'
import { LOCAL_STORAGE_DOWNLOAD_MANAGER_KEY } from 'utils/constants'

export const DOWNLOAD_MANAGER_INITIAL_STATE = { downloads: [] }
export const DOWNLOAD_MANAGER_STORAGE = appLocalStorage.getValue(LOCAL_STORAGE_DOWNLOAD_MANAGER_KEY)
export const DOWNLOAD_SERVICE_LEGACY = '1'
export const DOWNLOAD_SERVICE_V2 = '2'

export const DOWNLOAD_MANAGER_DOWNLOADS_KEY = 'downloads'

export const DOWNLOAD_MANAGER_POLLING_DELAY = 5000

export const DOWNLOAD_MANAGER_PENDING_STATUS = 'pending'
export const DOWNLOAD_MANAGER_READY_STATUS = 'ready'
export const DOWNLOAD_MANAGER_REQUESTED_STATUS = 'requested'
export const DOWNLOAD_MANAGER_COMPLETED_STATUS = 'completed'
